var config        = require("app/config"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    kind          = require("enyo/kind");

require("app/ui/VideoSlider.less");
require("app/theme/IconButton--slider.less");

/**
 * [VideoSlider]{@link app.ui.VideoSlider} Displays a video slider
 *
 * @ui
 * @class    app.ui.VideoSlider
 * @extends  app.ui.Slider
 * @public
 */
module.exports = kind(/** @lends  app.ui.VideoSlider.prototype */ {

    /**
     * @private
     */
    name: "app.ui.VideoSlider",

    /**
     * @private
     */
    classes: "app-ui-video-slider",

    /**
     * @private
     */
    components: [{
        name:       "video",
        tag:        "video",
        attributes: {
            src:                   this.videoSource,
            autoplay:              true,
            controls:              false,
            muted:                 true,
            playsinline:           true,
            loop:                  true,
            disableRemotePlayback: true,
            "x-webkit-airplay":    "deny"
        },
        classes: "app-ui-video-slider__video enyo-fit"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state       = this.state || {},
            videoSource = get(state, "preview_url", null),
            videoCdn    = get(config, "previewUrlPrefix", "");

        if (typeof videoSource === "string"
        && videoSource.substring(0, 4) !== "http") {
            videoCdn    = videoCdn.replace(/\/+$/, "");
            videoSource = videoSource.replace(/^\/+/, "");
            videoSource = videoCdn + "/" + videoSource;
        }
        this.$.video.setAttribute("src", videoSource);
    }
});
